/**
 * If Safari, force it to treat dates with some God Damned Respect!
 * (workaround for Safari auto-magically applying UTC offset into local time)
 */
function isSafari() {
    var ua = typeof window !== 'undefined'
        ? window.navigator.userAgent.toLowerCase()
        : '';
    if (ua.includes('safari')) {
        if (!ua.includes('chrome')) {
            return true;
        }
    }
    return false;
}
export function safariSafeUTC(ts) {
    return isSafari() ? ts.replace(/-/g, '/').replace(/T/, ' ') : ts;
}
//# sourceMappingURL=safariSafeUTC.js.map